import ActivityContentWrapper from "@/pages/(app)/returns/view/components/return-activity/contents/activity-content-wrapper.tsx";
import ActivityIconWrapper from "@/pages/(app)/returns/view/components/return-activity/contents/activity-icon-wrapper.tsx";
import { ActivityItemHeader } from "@/pages/(app)/returns/view/components/return-activity/contents/activity-item-header.tsx";
import ActivityWrapper from "@/pages/(app)/returns/view/components/return-activity/contents/activity-wrapper.tsx";
import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Wrench } from "lucide-react";

type ExchangeVariantAutoResolvedParams = {
  lineItemId?: string;
  sku?: string;
  oldVariantId?: string;
  newVariantId?: string;
};

type ExchangeVariantAutoResolvedActivityProps = {
  activity: ReturnRequestLogDto;
};

/**
 * The system swapped an exchange target on its own, so the variant id on the
 * return no longer matches what the customer originally picked. That has to be
 * visible in the audit trail — it is the only trace of the repair (BBS-328).
 */
export default function ExchangeVariantAutoResolvedActivity({
  activity,
}: ExchangeVariantAutoResolvedActivityProps) {
  const t = useTranslation();
  const params = (activity.params ?? {}) as ExchangeVariantAutoResolvedParams;

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <Wrench className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <ActivityItemHeader title="" timestamp={activity.date}>
          {t("activities.exchangeVariantAutoResolved.title")}
        </ActivityItemHeader>
        <div className="flex flex-col gap-0.5 text-xs text-muted-foreground">
          <span>
            {t("activities.exchangeVariantAutoResolved.description", {
              sku: params.sku ?? "—",
            })}
          </span>
          <div className="flex items-center gap-1">
            <span className="line-through">{params.oldVariantId || "—"}</span>
            <span>→</span>
            <span className="font-medium">{params.newVariantId || "—"}</span>
          </div>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
